var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81517 2.94398C9.88349 2.77973 10.1162 2.77973 10.1845 2.94399L12.1571 7.68673C12.1859 7.75597 12.251 7.80329 12.3258 7.80928L17.446 8.21976C17.6233 8.23398 17.6952 8.45528 17.5601 8.57102L13.6591 11.9127C13.6021 11.9615 13.5772 12.038 13.5946 12.111L14.7865 17.1074C14.8278 17.2805 14.6395 17.4172 14.4877 17.3245L10.1041 14.647C10.0401 14.6079 9.95959 14.6079 9.89559 14.647L5.51199 17.3245C5.36017 17.4172 5.17192 17.2805 5.2132 17.1074L6.40503 12.111C6.42243 12.038 6.39756 11.9615 6.3406 11.9127L2.43956 8.57102C2.30445 8.45528 2.37636 8.23398 2.55369 8.21976L7.67387 7.80928C7.74863 7.80329 7.81375 7.75597 7.84256 7.68673L9.81517 2.94398Z",
    fill: "#F29913"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5263178d17e7db8efb9c424aa6f5c0ad.svg";
export { ForwardRef as ReactComponent };